import { AppState } from "@Safemate/Store/types";

export const selectFilter = ({log: { initialization: { filter }}}: AppState) =>  filter;
export const selectUserAuditLog = ({ log: { userAuditLog: { userAuditLog }}}: AppState) =>  userAuditLog;
export const selectDeviceAuditLog = ({ log: { deviceAuditLog: { deviceAuditLog }}}: AppState) =>  deviceAuditLog;
export const selectDeviceCallLog = ({ log: { deviceCallLog: { deviceCallLog }}}: AppState) =>  deviceCallLog;